export var USER_ORGANISATIONS_LOAD_REQUEST = 'USER_ORGANISATIONS_LOAD_REQUEST';
export var USER_ORGANISATIONS_LOAD_SUCCESS = 'USER_ORGANISATIONS_LOAD_SUCCESS';
export var USER_ORGANISATIONS_LOAD_FAILURE = 'USER_ORGANISATIONS_LOAD_FAILURE';
export var USER_ORGANISATION_CHANGE = 'USER_ORGANISATION_CHANGE';